export const calculatePercentage = (
  amount: number | undefined,
  totalAmount: number | undefined
) => {
  if (amount == undefined || totalAmount == undefined) return null;
  if (totalAmount == 0) return null;
  return (100 * amount) / totalAmount;
};

export const safeCalculatePercentage = (
  amount: number | undefined,
  totalAmount: number | undefined
): number => {
  if (amount == undefined || totalAmount == undefined) return 0;
  if (totalAmount == 0) return 0;
  return (100 * amount) / totalAmount;
};
